import {SectionCard, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";

const SubaglomeracionDatosPrincipaisSection = ({subaglomeracion}) => {
    return (
        <SectionCard title="Datos principais">
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Código aglomeración:"
                        value={subaglomeracion.stats.codigoaglomeracion}
                    />
                    <SectionField
                        label="Nome aglomeración:"
                        value={subaglomeracion.stats.nomeaglomeracion}
                    />
                    <SectionField
                        label="A.P. Responsable do servizo:"
                        value={subaglomeracion.administracion_responsable_label}
                        tooltipText="Administración pública responsable do servizo. Administración pública que ten a
                            competencia para prestar os distintos servizos vinculados ao ciclo integral da auga, na
                            aglomeración, consonte o disposto na Lei 7/1985, do 2 de abril, reguladora das bases do
                            réxime local, nos termos establecidos na lexislación estatal e autonómica."
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    {/*
                    <SectionField
                        label="Código concello:"
                        value={subaglomeracion.stats.codigoconcello}
                        linkPath={`/concellos/${subaglomeracion.stats.codigoconcello}`}
                    />
                    */}
                    <SectionField
                        label="Concello:"
                        value={subaglomeracion.stats.nomeconcello}
                        linkPath={`/concellos/${subaglomeracion.stats.codigoconcello}`}
                        tooltipText="Concello ao que pertence o sistema colector"
                    />
                    <SectionField
                        label="Código EDAR:"
                        value={subaglomeracion.stats.codigoedar}
                        linkPath={`/concellos/${subaglomeracion.stats.codigoconcello}/edars/${subaglomeracion.stats.idedar}/summary`}
                        tooltipText="EDAR da aglomeración"
                    />
                    <SectionField
                        label="Nome EDAR:"
                        value={subaglomeracion.stats.nomeedar}
                        linkPath={`/concellos/${subaglomeracion.stats.codigoconcello}/edars/${subaglomeracion.stats.idedar}/summary`}
                        tooltipText="EDAR da aglomeración"
                    />
                    <SectionField
                        label="Tratamento:"
                        value={subaglomeracion.stats.tratamento}
                        tooltipText="Nivel de tratamento"
                    />
                </Grid>
            </Grid>
        </SectionCard>
    );
};

export default SubaglomeracionDatosPrincipaisSection;
